module.exports = __webpack_public_path__ + "img/total_accumulated_icon.8d394fbe.png";